__turbopack_context__.v({
  "count": "select-component-module-scss-module__ln2HeG__count",
  "label": "select-component-module-scss-module__ln2HeG__label",
  "option": "select-component-module-scss-module__ln2HeG__option",
  "select": "select-component-module-scss-module__ln2HeG__select",
});
